
/**
 * Draws the path to the selected nodes
 * @param {*} svg the svg box to draw the lines in
 * @param {*} path path element thats gonna change attributes too
 * @param {*} startY start position Y
 * @param {*} startX start position X
 * @param {*} endY end position Y
 * @param {*} endX end position X
 * @param {*} startWidth the width of the starting object
 * @param {*} endWidth the width of the ending object
 * @todo alot of commented code because this is still a bit broken
 */
function drawPath(svg, path, startY, startX, endY, endX, startWidth, endWidth) {

    let svgElement = document.getElementById(svg);
    let pathElement = document.getElementById(path);
    let stroke;
    const startPosition = startX;
    const endPosition = endX;
    if (pathElement !== null) {
        if (pathElement.getAttribute("stroke-width")) {
            stroke = parseFloat(pathElement.getAttribute("stroke-width"));
        }
        if (svgElement.getAttribute("height") < endY) {
            svgElement.setAttribute("height", endY);
        }
        if (svgElement.getAttribute("width") < (startPosition + stroke)) {

            svgElement.setAttribute("width", (startPosition, stroke) + 30);
        }
        if (svgElement.getAttribute("width") < (endPosition + stroke)) {

            svgElement.setAttribute("width", (endPosition + stroke) + 30);
        }

        // let deltaX = (endX - startX) * 0.15;
        // let deltaY = (endY - startY) * 0.35;

        // let delta = deltaY < absolute(deltaX) ? deltaY : absolute(deltaX);
        // // let delta = deltaY;
        // let arc1 = 0, arc2 = 1;
        // if (startX > endX) {
        //     arc1 = 1;
        //     arc2 = 0;
        // }
        // endX = 0;
        let hori;
        // startX = startX - 25;
        // endX = endX - 25;


        // im embrassed by this code but i cant figure it out
        //this just removes horizontal line if the divs below it (ish)
        if (endX === startX)
        // || (endX + 2 === startX) || (endX + 1 === startX)
        //     || (endX + 3 === startX) || (endX + 4 === startX)
        //     || (endX + 5 === startX) || (endX + 6 === startX))
        {
            hori = "";
        } else {
            hori = " H" + (endX);

        }
        const diff = (endY - startY) / 2;
        pathElement.setAttribute("d", "M" + startPosition + " " + startY
            +
            " V" + (startY + diff) +
            // " V" + (startY + delta) +
            // " A" + delta + " " +  delta + " 0 0 " + arc1 + " " + (startX + delta*signum(deltaX)) + " " + (startY + 2*delta) +
            hori +
            // " H" + (endX - delta*signum(deltaX)) + 
            // " A" + delta + " " +  delta + " 0 0 " + arc2 + " " + endX + " " + (startY + 3*delta) +
            " V" + endY
        );
    }



}
/**
 * helps connect the elements together and does the basic bit of maths needed for the calculation
 * @param {*} path path element
 * @param {*} startElem starting node
 * @param {*} endElem ending node
 */
export default function connectElements(path, startElem, endElem) {
    let startElement = document.getElementById(startElem);
    let endElement = document.getElementById(endElem);

    if (path === null || path === undefined) {
        return;
    }
    if (endElement === null || startElement === null) {
        let pathElement = document.getElementById(path);
        if (pathElement === null || pathElement === undefined) {
            return;
        }
        pathElement.setAttribute("d", "M0 0");
        return;
    }
    if (startElement.offsetTop > endElement.offsetTop) {
        let temp = startElement;
        startElement = endElement;
        endElement = temp;
    }
    // let svgTop = svgContainer.offsetTop;
    // let svgLeft = svgContainer.offsetLeft;

    let container = document.getElementById("container");
    let containerEl = {
        top: container.offsetTop,
        left: container.offsetLeft
    };

    let startCoord = findAbsolutePosition(startElement);
    let endCords = findAbsolutePosition(endElement);
    let screenWidth = window.innerWidth;
    let divison;
    //this is how i've done some of the line scaling, not sure if right
    //dont hate me
    if(screenWidth > 1900){
        divison = 1.35;
    }else if(screenWidth > 1700){
        divison = 1.3;
    // }else if(screenWidth > 1500){
    //     divison = 1.1;
    // }else if (screenWidth > 1300) {
    //     divison = 1.1;
    // } else if(screenWidth < 1300){
    //     divison = 1.1;
    }else{
        divison = 1.1;
    }
    let startX = startCoord.left + startElement.offsetWidth - (containerEl.top / divison);
    let startY = startCoord.top + startElement.offsetHeight - containerEl.top;

    let endX = endCords.left + endElement.offsetWidth - (containerEl.top / divison);
    let endY = endCords.top - containerEl.top + 1;

    let startWidth = startElement.offsetWidth;
    let endWidth = endElement.offsetWidth;
    drawPath("svg1", path, startY, startX, endY, endX, startWidth, endWidth);


}

/**
 * this is a copy of a jquerry class to find the elements positions
 * @param {*} htmlElement html element that you want to find the posion for
 */
function findAbsolutePosition(htmlElement) {
    // var x = htmlElement.offsetLeft;
    // var y =htmlElement.offsetTop;
    for (var x = 0, y = 0, el = htmlElement;
        el !== null;
        el = el.offsetParent) {
        x += el.offsetLeft;
        y += el.offsetTop;
    }
    return {
        "left": x,
        "top": y
    };
}




// WEBPACK FOOTER //
// ./src/services/svgDrawer.js